import api from "./api";
import endpoints from "./endpoints";

export default {
  get(args) {
    const response = api.get(endpoints.referenceTypes.get, { params: args }).then((x) => x.data);
    return response;
  },
  getReferenceTypes(languages) {
    return api
      .get(endpoints.attributeManager.referenceTypes.get, {
        params: { languages }
      })
      .then((x) => Promise.resolve(x.data));
  },
  updateReferenceTypes(model) {
    return api.post(endpoints.attributeManager.referenceTypes.update, model).then((x) => Promise.resolve(x.data));
  },
  deleteReferenceTypes(items) {
    return api.post(endpoints.attributeManager.referenceTypes.delete, items).then((x) => Promise.resolve(x.data));
  },
  savedeepLTranslated: async function (model, sourceLanguage) {
    return api
      .post(endpoints.attributeManager.referenceTypes.deepL, model, { params: { sourceLanguage: sourceLanguage } })
      .then((x) => Promise.resolve(x.data));
  }
};
